/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderSenddirectCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderSenddirectCtrl', ["dialog", "ngToast", "$scope", "$state", "$stateParams", "StockPurchaseOrders", "StockSuppliers", function(dialog, ngToast, $scope, $state, $stateParams, StockPurchaseOrders, StockSuppliers) {
  $scope.loginRequired = false;

  var credentialsRequired = function() {
    switch ($scope.supplier.orderDirectProvider) {
      case 'AlliedLiquor':
        var credentials = JSON.parse($scope.supplier.orderDirectCredentials);

        if (!credentials.login || !credentials.password) {
          $scope.credentials = credentials;
          return true;
        } else {
          return false;
        }
      break;
      case 'Email':
        return false;
      default:
        $scope.errorMessage = 'This supplier does not support direct ordering';
    }
  };

  var sendDirect = function(credentials) {
    $scope.loading = StockPurchaseOrders.direct($scope.order.id, credentials);
    $scope.loading.then(function(commLog) {
      if (commLog.message) {
        $scope.orderDirectResult = JSON.parse(commLog.message);
      }

      if (commLog.state == 'Failed') {
        $scope.errorMessage = commLog.notes;
      } else if (!commLog.message) {
        $state.go('^', {}, {reload: true});
      }
    });
  };

  $scope.order = StockPurchaseOrders.get($stateParams.id);
  $scope.loading = $scope.order.$promise;
  $scope.loading.then(function() {
    $scope.supplier = StockSuppliers.get($scope.order.supplierId);

    $scope.loading = $scope.supplier.$promise;
    $scope.loading.then(function() {
      $scope.loginRequired = credentialsRequired();

      if ($scope.loginRequired === false) {
        sendDirect();
      }
    });
  });

  $scope.confirmCredentials = function() {
    $scope.alliedCredentials.$setSubmitted();
    if ($scope.alliedCredentials.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please enter valid Allied Liquor credentials.');
      return;
    }

    $scope.loginRequired = false;

    sendDirect($scope.credentials);
  };

  $scope.closeDialog = function() {
    $state.go('^', {}, {reload: true});
  };
}]);
